export enum PortingOrigin {
  UNSET_PORTING_ORIGIN = 'UNSET_PORTING_ORIGIN',
  ORIGIN_MOBILE_APP = 'ORIGIN_MOBILE_APP',
  ORIGIN_CAPTIVE_PORTAL = 'ORIGIN_CAPTIVE_PORTAL',
  ORIGIN_PORTAL = 'ORIGIN_PORTAL',
  ORIGIN_API = 'ORIGIN_API',
  ORIGIN_INTERNAL = 'ORIGIN_INTERNAL',
  ORIGIN_OTHER = 'ORIGIN_OTHER',
}
